var map = {
	"./certificate.jpg": 9733,
	"./team-1.jpg": 1415,
	"./team-10.jpg": 2135,
	"./team-11.jpg": 3850,
	"./team-2.jpg": 3016,
	"./team-3.jpg": 181,
	"./team-4.jpg": 5182,
	"./team-5.jpg": 3019,
	"./team-6.jpg": 220,
	"./team-7.jpg": 8265,
	"./team-8.jpg": 9554,
	"./team-9.jpg": 1935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7781;